import DeleteFeedbackForm from "@memorang/ui/components/Account/DeleteForm/DeleteFeedbackForm";
import DeleteOptions from "@memorang/ui/components/Account/DeleteOptions";
import CustomKeyboardAvoidingView from "@memorang/ui/components/CustomKeyboardAvoidingView";
/* ----------------- UI --------------- */
import { Dialog } from "react-native-paper";

/* ----------------- Features --------------- */
import { dialogTexts } from "@features/feedback/constants";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import MarkdownRenderer from "@memorang/ui/components/MarkdownRenderer";
import { useTranslation } from "react-i18next";

type Props = {
	visible: boolean;
	handleDismiss: () => void;
	handleSetFeedback: (feedback: string) => void;
	feedback: string;
	handleShowDeleteConfirmation: () => void;
	checkboxStates?: Record<string, "checked" | "unchecked">;
	handleSelectOption: (index: string) => void;
	selectedReasons?: string;
};
const DeleteFeedbackDialog = (props: Props) => {
	const {
		visible,
		handleDismiss,
		handleSetFeedback,
		feedback,
		handleShowDeleteConfirmation,
		checkboxStates,
		handleSelectOption,
		selectedReasons,
	} = props;

	const { t } = useTranslation();

	const title = t(dialogTexts.deletefeedback.title);
	const body = t(dialogTexts.deletefeedback.body);
	const options = t(dialogTexts.deletefeedback.options).split("|");
	const Body = () => <MarkdownRenderer textAlign="center" text={body} />;

	return (
		<DialogWrapper
			maxWidth={"xs"}
			visible={visible}
			handleClose={handleDismiss}
		>
			<Dialog.Icon icon="message-alert-outline" />
			<Dialog.Title
				style={{
					textAlign: "center",
				}}
			>
				{title}
			</Dialog.Title>
			<Dialog.Content>
				<CustomKeyboardAvoidingView scrollPosition={300}>
					<Body />
					<DeleteOptions
						options={options}
						handleSelectOption={handleSelectOption}
						checkboxStates={checkboxStates}
					/>

					<DeleteFeedbackForm
						handleDismiss={handleDismiss}
						selectedReasons={selectedReasons}
						handleSetFeedback={handleSetFeedback}
						feedback={feedback}
						handleShowDeleteConfirmation={handleShowDeleteConfirmation}
					/>
				</CustomKeyboardAvoidingView>
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default DeleteFeedbackDialog;
